import { render, staticRenderFns } from "./DashboardAlert.vue?vue&type=template&id=1e623b34"
import script from "./DashboardAlert.vue?vue&type=script&lang=js"
export * from "./DashboardAlert.vue?vue&type=script&lang=js"
import style0 from "./DashboardAlert.vue?vue&type=style&index=0&id=1e623b34&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports